import React from 'react'

const Team = () => {
  return (
    <section className="team py-5">
    <div className="container-fluid px-md-5 text-center">
      <h2 className="fw-bold mb-5">Meet Our Team</h2>
      <div className="row">
        <div className="col-md-3 col-6 mb-4">
          <div className="card shadow border-0">
            <img src="assets/test-3.jpg" className="card-img-top" alt="Team Member"/>
            <div className="card-body">
              <h6 className="fw-bold">John Doe</h6>
              <p className="text-muted">CEO</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-4">
          <div className="card shadow border-0">
            <img src="assets/test-4.jpg" className="card-img-top" alt="Team Member"/>
            <div className="card-body">
              <h6 className="fw-bold">Jane Smith</h6>
              <p className="text-muted">Marketing</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-4">
          <div className="card shadow border-0">
            <img src="assets/insta-1.jpg" className="card-img-top" alt="Team Member"/>
            <div className="card-body">
              <h6 className="fw-bold">Michael Lee</h6>
              <p className="text-muted">Developer</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-4">
          <div className="card shadow border-0">
            <img src="assets/test-3.jpg" className="card-img-top" alt="Team Member"/>
            <div className="card-body">
              <h6 className="fw-bold">Sarah Johnson</h6>
              <p className="text-muted">Designer</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Team